import Frame from "../common/Frame";
import React from "react";
import Footer from "../common/Footer";
import {appdata} from "../../logic_tmp/appdata/AppData";
import {useTranslation} from "react-i18next";
import i18next from "i18next";
import {registerConcersion} from "../../logic/funel/FacebookUtils";

export function ThankYouPage() {
    const {t} = useTranslation();
    registerConcersion('Purchase');
    window.gtag('event', 'conversion', {
        'send_to': 'AW-457108933/RBWeCL3apMAYEMXb-9kB',
        'transaction_id': ''
    });
    let thankYouForPaymentKey = "YouPaymentOKThankYou!";
    if (appdata.amount <= 0.01)
        thankYouForPaymentKey = "ThankYou!";
    let ISendToEmailKey = "ISendTicketsToEmail!";
    let SeeYouKey = "SeeYouOnConcert!";
    if (appdata.product["type"] === "RECORDING") {
        ISendToEmailKey = "ISendLinkToEmailRecording!";
        SeeYouKey = "PleasantВiewing!";
    } else if (appdata.product["type"] === "ONLINE") {
        ISendToEmailKey = "ISendLinkToEmailOnline!";
        SeeYouKey = "PleasantВiewing!";
    } else if (appdata.product["type"] === "OFFLINE") {
        if ((appdata.product["seatsType"] === "FIXED"))
        {
            ISendToEmailKey = "IWillSendTicketsToEmailLater!";
            SeeYouKey = "SeeYouOnConcert!";
        }
        else
        {
            ISendToEmailKey = "ISendLinkToEmailOffline!";
            SeeYouKey = "SeeYouOnConcert!";
        }
    } else if (appdata.product["type"] === "SUBSCRIPTION") {
        registerConcersion('Purchase');
        ISendToEmailKey = "CheckYouEmailIsentYouASmallPresent";
        SeeYouKey = ".";
    } else if (appdata.product["type"] === "DONATION") {
        registerConcersion('Purchase');
        thankYouForPaymentKey = "YouPaymentOKThankYouForSupport!";
        ISendToEmailKey = ".";
        SeeYouKey = ".";
    } else
    if (appdata.product["type"] === "PDF") {
        ISendToEmailKey = "ISendLinkToEmailPdf!";
        SeeYouKey = "PleasantReading!";
    }
    else
        throw Error("Unsupported type:" + appdata.product["type"])
    let facebookShareLink = undefined;
    try {
        // @ts-ignore
        facebookShareLink = appdata.product["promotionLinks"]["Facebook"][i18next.language];
    } catch (error) {

    }

    return (


        <div>
            <Frame>
                <h2 className="offer-pay__title" id="thankyoupage">
                    {t(thankYouForPaymentKey)}
                </h2>
                <br/>
                <h2 className="app-title">{t(ISendToEmailKey)}</h2>
                <h2 className="app-title">{appdata.customerEmail}</h2>
                <br/>
                <h2 className="app-title">{t(SeeYouKey)}</h2>
                {(facebookShareLink !== undefined) ?
                    <div>
                        <h2 className="app-title">{t("PleaseShareLinkOnFacebook")}</h2>
                        <div className="app-button d-flex justify-content-around">
                            <a href={facebookShareLink} className="app-btn app-btn-further next-step-btn">
                                <span>{t("Share!")}</span>
                            </a>
                        </div>
                    </div> : <div/>}

                <Footer></Footer>
            </Frame>
        </div>
    );
}

